import { useCallback } from 'react';

import { trackLeadFormGA } from '@telialt/gtm-tracking/src/events';
import type { LeadFormEventData, LeadFormTrackingContext } from '@telialt/gtm-tracking/src/types';
import { useSegment } from '@telialt/utils/src/segment';
import { useUserData } from '@telialt/utils/src/SSO/useUserData';

import type { LeadGAEventEcommerce } from '../model';

type EventParams = {
    email?: string;
    phone?: string;
};

export const useGAEvent = (gaTracking?: LeadFormTrackingContext, gaEventEcommerce?: LeadGAEventEcommerce) => {
    const segment = useSegment();

    const { isLoadingUserData, userData } = useUserData();

    const pushGAEvent = useCallback(
        (event: LeadFormEventData['event'], params?: EventParams) => {
            trackLeadFormGA({
                source: 'leadForm',
                data: {
                    event,
                    userData,
                    email: params?.email,
                    phone: params?.phone,
                    segment,
                    tracking: gaTracking,
                    modalEcommerce: gaEventEcommerce as LeadFormEventData['modalEcommerce'],
                },
            });
        },
        [gaEventEcommerce, gaTracking, segment, userData],
    );

    return { isLoading: isLoadingUserData, pushGAEvent };
};
